import { PricingTypeDisplay } from '~/constants';
import { Project } from '~/types/project';

export default function headerText(project: Project) {
  const pricingTypeDisplay = PricingTypeDisplay[project?.pricingType];
  return `Deal Summary${pricingTypeDisplay ? ` — ${pricingTypeDisplay}` : ''}`;
}